
import {string_cmp} from "../../../lib/js-utils";
import {dump_timestamp} from "./common";
import {dollarToString} from "../../../lib/currency-utils";
import {sprintf} from "sprintf-js";
import { saveAs } from "file-saver";

const dump_date = () => {
  const d = new Date();
  return sprintf("%04d-%02d-%02d", d.getFullYear(), d.getMonth() + 1, d.getDate());
}

const save_csv_blob = (items, do_lastname_firm) => {
  let csv = "";

  const filename = sprintf("purchase_items.%s.csv", dump_date());
  items.sort((a, b) => string_cmp(a.id, b.id));
  const cols = do_lastname_firm
    ?  [ "ticket id", "timestamp", "state", "firm", "last name",
      "amt usd", "cusip", "coupon", "maturity", "issuer", "settle date",
    ] : [ "ticket id", "timestamp", "state", "account", "name", "email",
    "amt usd", "cusip", "coupon", "maturity", "issuer", "settle date",
  ];

  csv += cols.join(",") + "\n";

  items.forEach(item => {
    let line = [
      sprintf("\"%s\"", item.id),
      dump_timestamp(item.timestamp_sec),
      item.metadata.state];
    if (do_lastname_firm) {
      line.push(item.metadata.firm_name);
      line.push(item.metadata.last_name);
    } else {
      line.push(item.metadata.account_number);
      line.push(item.metadata.name);
      line.push(item.metadata.email);
    }
    line = line.concat([
      dollarToString(item.metadata.amt_usd).replace(",", ""), // remove commas
      item.metadata.cusip,
      item.metadata.cusip_metadata.Coupon,
      item.metadata.cusip_metadata.Maturity,
      item.metadata.cusip_metadata.Issuer,
      item.metadata.cusip_metadata['Settle Date'],
    ]);
    csv += line.join(",") + "\n";
  })

  const blob = new Blob([csv], {type: "text/plain"});
  saveAs(blob, filename);
}

export { save_csv_blob };
